import React, {
	useState,
	useEffect,
	useCallback,
	useMemo,
} from 'react';
import {
 	useSelector,
 	useDispatch,
} from 'react-redux';

import {
	NoColumnFilter,
	//GlobalFilter,
	//DefaultColumnFilter,
	//fuzzyTextFilterFn
} from 'components/utils/tableFilters.js'

import {
	actionSetMessage,
	actionResetMessages
} from 'components/messages/actions.js';

/* import {
	getLastDayOfWk,
	getFirstDayOfMth,
	//getLastDayOfMth
} from 'components/utils/dateLib.js';
 */
import RptBtns from 'components/rptBtns.js';
import { TableControl, TableStyles } from 'components/tableControl.js'
import { CheckAuth } from 'pages/auth/actions.js';
import { ClientSessionSelect } from 'components/clientSessionSelect/clientSessionSelect.js';
import Header from 'components/header.js';
import Footer from 'components/footer.js';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import OPWBreadcrumb from 'components/breadcrumb.js';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Loading from 'components/loading.js';
import TimePeriodSelect from 'components/timePeriodSelect.js';
import { actionFetchLongTermData, getDownloadFile } from './actions.js';
import { format } from 'date-fns';
import isValid from 'date-fns/isValid'
//import DatePicker from 'react-datepicker';
import { DateParamControl, stdDateFormatStr, shoeBoxDate} from 'components/dateParamControl.js'
import 'react-datepicker/dist/react-datepicker.css';
import { saveAs } from 'file-saver';
import styled from 'styled-components'

const TITLE = 'Data over time'
const showRecCount = 50	// default records to display

const BC = OPWBreadcrumb;

// this is specifically for this table and overwrites TableStyles.
const LongTermDataTableStyles = styled.div`
	th#visId input {max-width: 4rem;}
	th#eid input {max-width: 8rem;}
	tr {
		td {
			padding-left: 0.2rem;
			padding-right: 0.2rem;
		}
	}
`


const ParamPanel = (props) => {
	//console.log('ParamPanel()', props)
	const { timePeriod, setTimePeriod, loading, handleDownload, downloading } = props;
	const handleTimePeriodChange = (evt) =>{
		setTimePeriod(evt.target.value)
	}
	return (
		<Card
			className={'no-print'}
			body
		>
			<Card.Title>{TITLE}</Card.Title>
			<Card.Body>
			<Row>
				<Col sm={ 4 }>
					<ClientSessionSelect
						lock = { loading }
						layout = { 'select' }
						hideSessionSelect = { false }
						handleBeforeSessionChange = {()=>{}}
					/>
					</Col>
				<Col sm={ 4 }>
					<TimePeriodSelect
						value = { timePeriod }
						cols = { {lhs: 4, rhs: 8} }
						handleChange = { (evt) => handleTimePeriodChange(evt) }
						//handleChange = { (evt) => setTimePeriod(evt) }
						controlStyle = { {} }
						required = { true }
						lock = { loading }
						className = "inputRow"
					/>
					<DateParamControl
						{ ...props }
					/>
					<Loading loading = { loading } />
					{/* <p>DEBUG timePeriod: { timePeriod }</p>
					<p>DEBUG dateParam: { dateParam }</p> */}
				</Col>
				<Col sm={ 4 }>
					<div className={'text-right report-buttons'}>
						<RptBtns
							enablePrint = { true }
							enableHelp = { true }
							enableDownload = { true }
							//handleDownload = {() => { alert('Optiweigh feature coming soon - thanks for your patience.') }}
							handleDownload = { () => handleDownload() }
							downloading = { downloading }
						/>
					</div>
					<div className={'dt-leftMargin note'}>
						Notes:
						<ol>
							<li>Animals are selected by having session membership.
							Weight data is shown for the selected animals across ALL sessions.</li>
							<li>visualId may be empty if yard weight data has never been recorded.</li>
							<li>Animals with zero avgWt or count belong to the Session but did not register a reading in the date range</li>
						</ol>
					</div>
				</Col>
			</Row>
			</Card.Body>
		</Card>
	)
}


const Template = (props) => (
	<div>
		<Header><BC trail='[["Home", "/"], ["reports", "/"], ["data over time", ""]]' /></Header>
		<Container fluid className="body">
			<CheckAuth groupName = { 'user' }/>
			<ParamPanel
				{ ...props }
			/>
			{ props.children }
		</Container>
		<Container fluid>
			<Row>
				<Col sm='12'>
					<Footer />
				</Col>
			</Row>
		</Container>
	</div>
)

export const LongTermData = (props) => {
	/**
	 *
	 *
	 *
	 */

	// const dispatch = useDispatch()
	const [timePeriod, setTimePeriod] = useState('day');//	day, week, month
	//const [timePeriod, setTimePeriod] = useState('week');//	day, week, month
	const [dateParam, setDateParam] = useState(new Date());//	day=date, week=date of end of week, month=date of start of month
	const [lowerDate, setLowerDate] = useState(null)
	const [upperDate, setUpperDate] = useState(null)
	const [loading, setLoading] = useState(false);
	//const [oFormat, setOFormat] = useState('')
	const [xTabFields, setXTabFields] = useState([])//	list of fields for a xtab query supplied by the server
	const [data, setData] = useState([])
	const [downloading, setDownloading] = useState(false);
	const session = useSelector(state => state.session);
	//const sessionId = useSelector(state => state.sessionId);

	//console.log('dateParam',dateParam)
	const dispatch = useDispatch()

	const showMessage = useCallback(
		(data) => dispatch(actionSetMessage(data)),
		[dispatch]
	)

	const getOFormat = (timePeriod) =>{
		switch (timePeriod){
			case 'week':
				return 'xtab';
			case 'month':
				return 'xtab';
			case 'day'://fallthrough
			default:
				return '';
		}
	}

	const handleDownload = async () => {
		setDownloading(true);
		let eid = 'tba';//use only for animal view
		const { data } = await getDownloadFile(timePeriod, format(dateParam, stdDateFormatStr), session.SessionID, eid)
		await saveAs(data, 'session_data.csv')
		setDownloading(false);
	}

	useEffect(() => {//set upper and lower date limits to the session dates
		const dstart = new Date(session.SessionStart)
		dstart.setHours( 0,0,0,0 );
		const dend = new Date(session.SessionEnd)
		dend.setHours( 0,0,0,0 );
		if (isValid(dstart)){
			setLowerDate(shoeBoxDate(dstart, timePeriod, null, null))
		}
		if (session.SessionEnd === null) {
			setUpperDate(shoeBoxDate(new Date(), timePeriod, null, null))
		} else if (isValid(dend)) {
			setUpperDate(shoeBoxDate(dend, timePeriod, null, null))
		}
	},[session, timePeriod])

	useEffect(() => {
		/*
			adjust the selected dateParam to
			a sensible value in the limits of the session range
		*/
		document.title = TITLE + timePeriod
		//update dateParam if it is not on a boundary suitable to the time period
		//eg. end of week, start of month
		const testDate = shoeBoxDate(dateParam, timePeriod, lowerDate, upperDate)
		if (!isValid(dateParam) || dateParam.getTime() !== testDate.getTime()){	//start with a semi realistic date
			//console.log(`B set dateParam from ${dateParam} to ${testDate}`)
			//:TODO: need to fix the endless loop
			//if (timePeriod !== 'week'){
				setDateParam(testDate);
			//}
		}
	},[timePeriod, dateParam, upperDate, lowerDate])

	useEffect(() => {
		async function fetchData() {

			dispatch(actionResetMessages())
			let eid = 'tba';//use only for animal view
			const oFormat = getOFormat(timePeriod)
			const resp = await actionFetchLongTermData(timePeriod, format(dateParam, stdDateFormatStr), session.SessionID, eid, oFormat, showMessage, setLoading)
			//console.log('resp',resp)
			if (oFormat === 'xtab'){
				if (resp.xTabData !== undefined && resp.xTabData.length > 0){
					//console.log('resp.xTabFields',resp.xTabFields)
					//console.log('resp.xTabData',resp.xTabData)
					setXTabFields(resp.xTabFields)
					setData(resp.xTabData)
				} else {
					setData([])
				}
			} else {
				setData(resp)
			}
		}

		if (session.SessionID > 0 && timePeriod.length > 0 && isValid(dateParam)){
			//console.log('dd',format(dateParam, formatStr))

			setData([])//clear as lots of column changes and looks wierd
			setLoading(true)
			fetchData();
		}
	},[timePeriod, session.SessionID, dateParam, showMessage, dispatch])


	//console.log('data', data)
	//console.log('xTabFields',xTabFields)

	// :TODO: get sensible starting date for dat week month
	// const getDefaultDateParam = (timePeriod, dateParam) => {
	// 	const def = new Date()
	// 	return format(def, formatStr)
	// }

	//console.log('data', data)
	//console.log('timePeriod', timePeriod)
	const masterProps = {
		timePeriod: timePeriod,
		setTimePeriod: setTimePeriod,
		dateParam: dateParam,
		setDateParam: setDateParam,
		lowerDate: lowerDate,
		setLowerDate: setLowerDate,
		upperDate: upperDate,
		setUpperDate: setUpperDate,
		session: session,
		loading: loading,
		handleDownload: handleDownload,
		downloading: downloading,
		dayLabel: 'Sample Date:'
	}

	if (timePeriod === 'day'){
		return (
			<Template { ...masterProps } >
				<LongTermDataTableDay
					data = { data }
					session = { session }
					dateParam = { dateParam }
					//sessionObj = { sessionObj[0] || '' }
				/>
			</Template>
		)
	} else if (timePeriod === 'week'){
		return (
			<Template { ...masterProps } >
			{/* <pre>{ JSON.stringify(data) }</pre> */}
				<LongTermDataTableWeek
						data = { data }
						xTabFields = { xTabFields }
						session = { session }
						dateParam = { dateParam }
						//sessionObj = { sessionObj[0] || '' }
				/>
			</Template>
		)
	} else if (timePeriod === 'month'){
		return (
			<Template { ...masterProps } >
				<LongTermDataTableMonth
						data = { data }
						xTabFields = { xTabFields }
						session = { session }
						dateParam = { dateParam }
						//sessionObj = { sessionObj[0] || '' }
				/>
			</Template>
		)
	} else {
	//return ( <>Error - unknown timePeriod: { timePeriod }</> )
	return ( <>Error - unknown timePeriod</> )
	}
}

const NoData = () => (
	<h1>No data</h1>
)

const LongTermDataTableDay = (props) => {
	//console.log('props', props)
	//console.log('LongTermDataTableDay()',props)
	const {
		dateParam,
		session,
		data
	} = props
	//console.log('dateParam',dateParam)
	const fdate = (isValid(dateParam))?format(dateParam,'dd MMM yyyy'):'';
	//console.log('fdate',fdate)
	const columns = useMemo(
		() => [
			{
				Header: `Data for session: ${session.SessionID}, Date: ${fdate}`,
				Footer: '',
				columns: [
				{
					Header: 'RFID',
					accessor: 'eid',
					sortType: 'basic',
					style: {textAlign: 'center',},
					Footer: 'Average',
				},
				{
					Header: 'Visual ID',
					accessor: 'visId',
					sortType: 'basic',
					style: {textAlign: 'center',},
					Footer: '',
				},
				{
					Header: 'Average Wt [kg]',
					accessor: 'avWt',
					sortType: 'basic',
					//filter: 'fuzzyText',
					style: {textAlign: 'right',},

					Footer: info => {
						const avgObj = React.useMemo(
							() => info.rows.reduce((dataObj, row) => {
								//console.log('row', row)
								//console.log('dataObj', dataObj)
									if (isNaN(row.values.avWt) || row.values.avWt === null){//only include numeric in calcs
										return dataObj;
									} else {
										return {sum: row.values.avWt + dataObj.sum, count: dataObj.count+1}
									}
								}, {sum: 0, count: 0}),
							[info.rows]
						)
						//console.log('avgObj', avgObj);
						const avg = (avgObj.count > 0) ? parseFloat(Math.round(avgObj.sum/avgObj.count)).toLocaleString('en'): 'n/a';
						//console.log('avg',avg)
						return <>{ avg }</>
					},
				},
				{
					Header: 'Sample Count',
					accessor: 'n',
					//Filter: SelectColumnFilter,
					//filter: 'includes',
					style: {textAlign: 'right',},
					Footer: info => {
						// Only calculate total visits if rows change
						const total = React.useMemo(
							() =>
								info.rows.reduce((sum, row) =>
									//console.log('debug row', row)
									row.values.n + sum, 0
							),
						[info.rows]
						)
						return <>{ parseFloat(total).toLocaleString('en') }</>
					},
				},
				],
			},
		],
		[session, fdate]
	)

	// console.log('columns', columns)
	// console.log('data', data)
	// console.log('showRecCount',showRecCount)
	// throw new Error('debug stop here');
	return (
		<TableStyles className="sessionDataTable">
			<LongTermDataTableStyles>
				<TableControl
					columns = { columns }
					data = { data }
					showRecCount = { showRecCount }
					NoDataComponent={ NoData }
					//selectSet={(id) => selectSet(id)}
				/>
			</LongTermDataTableStyles>
		</TableStyles>
	)
}

const LongTermDataTableWeek = (props) => {
	//console.log('props', props)
	const { dateParam, session, data, xTabFields } = props

	//console.log('xTabFields', xTabFields)
	//console.log('data', data)
	//console.log('dateParam',dateParam)
	const fdate = (isValid(dateParam))?format(dateParam,'dd MMM yyyy'):'';

	let weekAverage = null;
	const dataWithTotals = data.reduce(function (res, set) {
		let dsum = 0;
		let dcount = 0;
		if (xTabFields.length > 0){
			//console.log('set',set)
			for (let i = 0; i < xTabFields.length; i++) {
				if (set[xTabFields[i]] !== null){
					//console.log('set[xTabFields[i]]',set[xTabFields[i]])
					dsum += set[xTabFields[i]];
					dcount += 1;
					//console.log(`dcount1: ${dcount}, dsum1: ${dsum}`);
				}
			}
			//console.log(`dcount: ${dcount}, dsum: ${dsum}`);
			//throw new Error('stop here! debug');
		}
		if (dcount > 0){
			weekAverage = (dsum/dcount).toFixed(0);
		} else {
			weekAverage = null;
		}
		res.push({...set, ...{weekAvg: weekAverage}})
		return res;
	}, []);
	//console.log('dataWithTotals',dataWithTotals)

	const buildColumns = (xTabFields) => {
		const columnsPre = [
			{
				Header: 'RFID',
				accessor: 'eid',
				sortType: 'basic',
				style: {textAlign: 'center',},
				Footer: 'Average',
			},
			{
				Header: 'Visual ID',
				Footer: '',
				accessor: 'visId',
				sortType: 'basic',
				style: {textAlign: 'center',},
			},
		]

		const columnsXTab = xTabFields.map(colIdentifier => {
			//console.log('colIdentifier', colIdentifier)
			return 	{
				Header: colIdentifier,
				//Footer: '',
				Footer: info => {
					const avgObj = React.useMemo(
						() => info.rows.reduce((dataObj, row) => {
							//console.log('row.values id: '+colIdentifier, row.values)
								if (row.values[colIdentifier] == null || isNaN(row.values[colIdentifier])){//only include numeric in calcs
									//console.log('skipped', row.values[colIdentifier])
									return dataObj;
								} else {
									//console.log('added', row.values[colIdentifier])
									return {sum: row.values[colIdentifier] + dataObj.sum, count: dataObj.count+1}
								}
							}, {sum: 0, count: 0}),
						[info.rows]
					)
					//console.log('avgObj', avgObj);
					const avg = (avgObj.count > 0) ? parseFloat(Math.round(avgObj.sum/avgObj.count)).toLocaleString('en'): '';
					//console.log('avg',avg)
					return <>{ avg }</>
				},

				accessor: colIdentifier,
				sortType: 'basic',
				Filter: NoColumnFilter,
				style: {textAlign: 'right',},
			}
		})

		const columnsPost = [
			{
				Header: 'Wk Avg',
				Footer: '',
				accessor: 'weekAvg',
				sortType: 'basic',
				style: {textAlign: 'center',},
				Filter: NoColumnFilter,
			},
			// {
			// 	Header: 'Sample Cnt',
			//  Footer: '',
			// 	accessor: 'sampleCount',
			// 	sortType: 'basic',
			// 	style: {textAlign: 'center',},
			// },
		]
		return [...columnsPre, ...columnsXTab, ...columnsPost]
	}

	const columns = useMemo(
		() => [
		{
			Header: `Data for session: ${session.SessionID}, Week ending Sunday ${fdate}`,
			Footer: '',
			columns: buildColumns(xTabFields),
		},
		],
		[fdate, session, xTabFields]
	)
	//console.log('columns', columns)
	//console.log('data', dataWithTotals)
	//console.log('showRecCount',showRecCount)
	return (
		<TableStyles className="sessionDataTable">
			<LongTermDataTableStyles>
				<TableControl
					columns = { columns }
					data = { dataWithTotals }
					showRecCount = { showRecCount }
					NoDataComponent={ NoData }
					//selectSet={(id) => selectSet(id)}
				/>
			</LongTermDataTableStyles>
		</TableStyles>
	)
}

const LongTermDataTableMonth = (props) => {
	//console.log('props', props)
	const { dateParam, session, data, xTabFields } = props
	// console.log('session',session)
	// console.log('xTabFields', xTabFields)
	// console.log('data', data)
	// console.log('dateParam',dateParam)
	const fdate = (isValid(dateParam))?format(dateParam,'dd MMM yyyy'):'';
	const buildColumns = (xTabFields) => {
		const columnsPre = [
			{
				Header: 'RFID',
				accessor: 'eid',
				sortType: 'basic',
				style: {textAlign: 'center',},
				Footer: 'Average',
			},
			{
				Header: 'Visual ID',
				Footer: '',
				accessor: 'visId',
				sortType: 'basic',
				style: {textAlign: 'center',},
			},
		]

		const columnsXTab = xTabFields.map(colIdentifier => {
			return 	{
				Header: colIdentifier,
				accessor: colIdentifier,
				sortType: 'basic',
				Filter: NoColumnFilter,
				style: {textAlign: 'right',},
				Footer: info => {
					const avgObj = React.useMemo(
						() => info.rows.reduce((dataObj, row) => {
							//console.log('row.values id: '+colIdentifier, row.values)
								if (row.values[colIdentifier] == null || isNaN(row.values[colIdentifier])){//only include numeric in calcs
									//console.log('skipped', row.values[colIdentifier])
									return dataObj;
								} else {
									//console.log('added', row.values[colIdentifier])
									return {sum: row.values[colIdentifier] + dataObj.sum, count: dataObj.count+1}
								}
							}, {sum: 0, count: 0}),
						[info.rows]
					)
					//console.log('avgObj', avgObj);
					const avg = (avgObj.count > 0) ? parseFloat(Math.round(avgObj.sum/avgObj.count)).toLocaleString('en'): '';
					//console.log('avg',avg)
					return <>{ avg }</>
				},
			}
		})

		// const columnsPost = xTabFields.map(row => {
		// 	return 	[{
		// 		// Header: row,
		//		// Footer: '',
		// 		// accessor: row,
		// 		// sortType: 'basic',
		// 		// Filter: NoColumnFilter,
		// 		// style: {textAlign: 'right',},
		// 	}]
		// })
		return [...columnsPre, ...columnsXTab]
	}

	const columns = useMemo(
		() => [
		{
			Header: `Data for session: ${session.SessionID}, Month ending: ${fdate}`,
			Footer: '',
			columns: buildColumns(xTabFields),
		},
		],
		[fdate, session, xTabFields]
	)
	//throw new Error('debug stop here');
	return (
		<TableStyles className="sessionDataTable">
			<LongTermDataTableStyles>
				<TableControl
					columns = { columns }
					data = { data }
					showRecCount = { showRecCount }
					NoDataComponent={ NoData }
					//selectSet={(id) => selectSet(id)}
				/>
			</LongTermDataTableStyles>
		</TableStyles>
	)
}